var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkflowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625 7.125C13.8525 7.125 13.2 7.59 12.9075 8.25H10.7175C10.425 7.59 9.7725 7.125 9 7.125C8.2275 7.125 7.575 7.59 7.2825 8.25H5.0925C4.8 7.59 4.1475 7.125 3.375 7.125C2.34 7.125 1.5 7.965 1.5 9C1.5 10.035 2.34 10.875 3.375 10.875C4.1475 10.875 4.8 10.41 5.0925 9.75H7.2825C7.575 10.41 8.2275 10.875 9 10.875C9.7725 10.875 10.425 10.41 10.7175 9.75H12.9075C13.2 10.41 13.8525 10.875 14.625 10.875C15.66 10.875 16.5 10.035 16.5 9C16.5 7.965 15.66 7.125 14.625 7.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowIcon);
export default __webpack_public_path__ + "static/media/workflow-icon.09182315809b1c72d97d7934a6fcbd9a.svg";
export { ForwardRef as ReactComponent };